import { useTranslate } from '@growtherapy/i18n';
import { Button, Text } from '@growtherapy/sprout-ui';

import { Translate } from '../i18n';
import { Toast } from '../toasts/Toast';
import { ModifiedToastAria, ToastVariant } from '../toasts/types';

export type SessionTimoutToastCommonProps = ModifiedToastAria & {
  isInSession: boolean;
};

export function SessionTimeoutToastBase({
  contentProps,
  descriptionProps,
  isInSession,
  onPressReLogin,
  titleProps,
  ...toastAriaProps
}: SessionTimoutToastCommonProps & {
  onPressReLogin: () => void;
}) {
  const t = useTranslate();
  return (
    <Toast alignment='top' className='sm:w-md' variant={ToastVariant.Error} {...toastAriaProps}>
      <div {...contentProps}>
        <Text as='h3' className='inline' {...titleProps}>
          {t('telehealth-core:errorsCore.yourLoginHasExpired')}{' '}
        </Text>
        <Text {...descriptionProps} className='inline'>
          <Translate
            i18nKey='telehealth-core:errorsCore.pleaseLogInAgain'
            components={{
              1: <Button className='p-0' use='link' onClick={() => onPressReLogin()} />,
            }}
          />
          {isInSession ? (
            <span> {t('telehealth-core:infoCore.thisWillNotDisruptYourCurrentTelehealthSession')}</span>
          ) : null}
        </Text>
      </div>
    </Toast>
  );
}
